<template>
  <div v-for="week in calendar" :key="week">
    <h3>Week of {{ week.label }}</h3>
    <table>
      <tr v-for="entry in week.entries" :key="entry">
        <td class="name">{{ entry.name }}</td>
        <td class="start">Start @ {{ entry.start }}</td>
        <td>End @ {{ entry.end }}</td>
      </tr>
    </table>
  </div>
</template> 

<script>
export default {
  props: [
    'calendar'
  ]
}
</script>

<style scoped>

</style>